import { ModelBase } from "../shared/model.base";
import { Grupo } from "../groups/grupo.type";
import { ShortCode } from "../shared/shortcode.type";
import { User } from "../security/user.type";
import { ContentSAT } from "./contentSAT.type";
import { IdName } from "../shared/id-name.type";

export class SatDTO extends ModelBase {
    contents: Array<ContentSAT>;
    execute_end_date: string;
    execute_time: string;
    message: string;
    recurrence_mode: string;

    groups: Array<Grupo>;
    shortCode: ShortCode;
    name: string;
    istracking: boolean;
    initTracking: boolean;

    service_type: string;

    create_date: string;
    execute_date: string;
    id_user: number;
    userId: number;
    user: User;

    operatorId: number;
    operator_id: number;
    organization_short_code_id: number;

    status: IdName;
    statusId: number;

    type: string;

    constructor() {
        super();

        this.name = "";
        this.istracking = false;
        this.initTracking = false;
        this.recurrence_mode = "1111111";
        this.execute_date = null;
        this.groups = new Array<Grupo>();
        this.status = new IdName(1, "Activo");
        this.status.id = 1;
        this.statusId = 1;

        this.service_type = "0";
    }
}
